//export const $BASE = "https://3.14.177.139";
export var $BASE = "https://vids.nexmo.com";
export var $NODEBASE = "https://vids.nexmo.com";// "http://zendeskci-668589864.us-east-2.elb.amazonaws.com";

if (0 && process.env.NODE_ENV === 'development') {
    //$NODEBASE = "https://mberkeland2.ngrok.io";
    $NODEBASE = "https://mberkeland3.ngrok.io"
}